import React, { useState } from 'react';
import { Body, Divider, IconButton, EllipsisLoader } from '@indigo-ag/component-module';
import { AgEconomicGroup } from '@indigo-ag/schema';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';

import { brazil, text } from 'shared';

export interface EconomicGroupsListProps {
  economicGroups?: AgEconomicGroup[];
  onUpdateEconomicGroup?: (newEconomicGroup: AgEconomicGroup[]) => Promise<any>;
  readonly?: boolean;
}

export const EconomicGroupsList: React.FunctionComponent<EconomicGroupsListProps> = ({
  economicGroups = [],
  onUpdateEconomicGroup,
  readonly = false
}) => {
  /**
   * State
   */
  const [economicGroupDeletedIdx, setEconomicGroupDeletedIdx] = useState<number | null>(null);

  const removeEconomicGroup = (idx: number) => {
    return () => {
      if (onUpdateEconomicGroup) {
        setEconomicGroupDeletedIdx(idx);
        onUpdateEconomicGroup(economicGroups.filter((p, i) => i !== idx)).finally(() => {
          economicGroupDeletedIdx && setEconomicGroupDeletedIdx(null);
        });
      }
    };
  };

  return economicGroups && economicGroups.length ? (
    <div className="width-100">
      {economicGroups.map(({ name = '', cpfCnpj = '' }, i) => {
        return (
          <div key={`economicGroup-${i}`}>
            <div style={{ minHeight: 48 }} className="flex flex-space-btw align-items-center mt-3 mb-1">
              <div className="flex flex-space-btw width-100" style={{ padding: '0 16px' }}>
                <Body>{text.firstLetterUppercase(name)}</Body>
                <Body className="mt-0">
                  {cpfCnpj?.length > 11 ? brazil.cnpjInputMask(cpfCnpj) : brazil.cpfInputMask(cpfCnpj)}
                </Body>
              </div>
              {!readonly ? (
                economicGroupDeletedIdx === i ? (
                  <div style={{ width: 44 }}>
                    <EllipsisLoader style={{ margin: '0px 10px' }} />
                  </div>
                ) : (
                  <IconButton label="delete" onClick={removeEconomicGroup(i)} icon={faTrashAlt} busy={true} />
                )
              ) : null}
            </div>
            <Divider />
          </div>
        );
      })}
    </div>
  ) : null;
};
